// ─────────────────────────────────────────────────────────────────────────
// ui-survey.js — Dashboard sondaggio (solo admin)
// Legge il CSV pubblicato del Google Form, aggrega e disegna con Chart.js.
// Due tab:
//   • Panoramica    → KPI, timeline, grafici per domanda, risposte aperte
//   • Considerazioni → sintesi strategica (AI) che COMPILA i framework di
//     validazione (Problem–Solution Fit, Javelin, Buyer Personas) e dice
//     e indica cosa manca per decidere. Si rigenera al crescere delle risposte.
// Tutto client-side (CSV con CORS aperto, dati anonimi). Insight via window.api.
// Gate admin: window.S.profile.is_admin. Segmentazione via colonna "router".
// ─────────────────────────────────────────────────────────────────────────

const CSV_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR3IaBvPmv-fOwmsGB_neLWbONDnpbgkg1zNn4Z5-H8ffvok9CW120y9Zj69vFRgF2jo-Iz1b3dzhgD/pub?output=csv';

const AC = '#1D9E75', AC2 = '#25c98f';
const H_ROUTER = 'Per le ultime domande, in quale veste preferisci rispondere';
const H_TS = 'Informazioni cronologiche';

const MULTI = {
  'Quali strumenti usi oggi per gestire allenamento': ['App per l’allenamento / schede','App per calorie/macro','App o portale del nutrizionista / PT','Excel / Google Sheets','Note sul telefono o diario cartaceo','Chat con nutrizionista / PT','Contenuti trovati online o sui social','Nessuno strumento specifico'],
  'Quali funzioni ti sarebbero più utili': ['Scheda di allenamento personalizzata','Guida all’esecuzione corretta degli esercizi (video)','Progressione automatica di carichi / volume','Varietà e nuovi esercizi quando serve','Idee pasto varie, in linea con obiettivi e gusti','Sostituzioni quando manca un ingrediente','Tenere sotto controllo i macronutrienti (proteine, carbo, grassi)','Lista della spesa automatica','Pianificare la settimana (allenamenti + pasti)','Tracciare progressi (peso, misure, performance)','Motivazione e promemoria quotidiani'],
  'Come preferiresti interagire': ['Chat con un assistente','Messaggi vocali','Dashboard interattiva (grafici e progressi)','Community con altri utenti'],
  'Dove scopri di solito app o contenuti': ['Instagram','TikTok','YouTube','Google','Consiglio di nutrizionista o PT','Palestra','Amici / passaparola','Community o forum'],
  'Qual è la parte più onerosa': ['Personalizzare il piano (allenamento o alimentare)','Creare e aggiornare schede di allenamento','Correggere a distanza l’esecuzione degli esercizi','Aggiornare il piano quando la persona non riesce a seguirlo','Dare alternative quando mancano ingredienti o cambiano gli impegni','Rispondere a dubbi e messaggi fuori orario','Monitorare costanza e aderenza nel tempo','Preparare documenti, schede, report'],
  'Quali strumenti digitali usi per gestire struttura': ['Nessuno / gestione cartacea','Software gestionale dedicato (es. Fitbooking, Wodify)','CRM generico','App proprietaria della palestra','App per schede di allenamento (es. TrainHeroic, PT Distinction)','Excel / Google Sheets'],
  'Per quel che osservi, perché i tuoi iscritti smettono': ['Mancanza di motivazione / risultati non visibili','Mancanza di tempo','Infortuni','Costo dell’abbonamento','Non si sentono seguiti personalmente','Cambiano palestra o metodo','Non lo monitoriamo / non lo sappiamo con certezza'],
  'Quali funzionalità sarebbero più utili per i tuoi soci': ['Schede di allenamento personalizzate con progressione automatica','Guida video all’esecuzione corretta degli esercizi','Consigli nutrizionali in linea con gli obiettivi dell’iscritto','Piano settimanale di meal prep e lista della spesa','Notifiche motivazionali e promemoria allenamento','Chat AI per domande rapide tra le sessioni','Tracking dei progressi (peso, misure, performance)','Adattamento automatico della scheda in caso di assenza'],
  'Quale metrica useresti per valutare il successo': ['Aumento dei rinnovi (meno abbandoni)','Aumento delle sessioni settimanali per iscritto','Soddisfazione / NPS degli iscritti','Riduzione del tempo degli istruttori su attività ripetitive','Aumento degli upgrade ad abbonamenti premium','Nuovi iscritti da passaparola'],
};

const SEC_COMMON = [
  { q:'Quale frase ti descrive meglio', type:'single', title:'Come si descrivono' },
  { q:'Quanti anni hai', type:'single', title:'Età' },
  { q:'Genere', type:'single', title:'Genere' },
  { q:'Area geografica', type:'single', title:'Area geografica' },
  { q:'Qual è il tuo obiettivo principale', type:'single', title:'Obiettivo principale' },
  { q:'Hai una scheda / programma di allenamento', type:'single', title:'Scheda di allenamento' },
  { q:'Segui un piano alimentare strutturato', type:'single', title:'Piano alimentare' },
  { q:'Con che frequenza ti alleni', type:'single', title:'Frequenza allenamento' },
  { q:'Quali strumenti usi oggi per gestire allenamento', type:'multi', title:'Strumenti usati oggi' },
  { q:'Quanto pianifichi in anticipo', type:'single', title:'Pianificazione' },
  { q:'Quanto ti riguardano queste difficoltà sull’ALLENAMENTO', type:'grid', title:'Difficoltà allenamento (media 1–5)' },
  { q:'Quanto ti riguardano queste difficoltà sull’ALIMENTAZIONE', type:'grid', title:'Difficoltà alimentazione (media 1–5)' },
  { q:'In generale, cosa ti pesa di più', type:'single', title:'Cosa pesa di più (bussola)' },
  { q:'Quanto spesso non sai cosa fare', type:'single', title:'"Non so cosa fare" — frequenza' },
  { q:'Hai mai abbandonato un percorso', type:'single', title:'Motivo di abbandono' },
  { q:'Hai mai usato app o strumenti digitali', type:'single', title:'Esperienza con app' },
  { q:'Quali funzioni ti sarebbero più utili', type:'multi', title:'Funzioni più utili' },
  { q:'Quanto conterebbe che lo strumento imparasse', type:'scale', title:'Valore: impara i tuoi gusti' },
  { q:'Quanto ti fideresti di suggerimenti automatici', type:'single', title:'Fiducia nell’AI' },
  { q:'Come preferiresti interagire', type:'multi', title:'Modalità di interazione' },
  { q:'Per uno strumento davvero utile nella gestione quotidiana', type:'single', title:'Modello di prezzo' },
  { q:'Dove scopri di solito app o contenuti', type:'multi', title:'Canali di scoperta' },
];
const SEC_PRO = [
  { q:'Quanti clienti / utenti segui', type:'single', title:'Clienti/mese' },
  { q:'Quanto tempo dedichi mediamente a creare', type:'single', title:'Tempo per piano' },
  { q:'Qual è la parte più onerosa', type:'multi', title:'Parte più onerosa' },
  { q:'Quanto sarebbe utile ridurre i messaggi ripetitivi', type:'scale', title:'Utilità: ridurre messaggi ripetitivi' },
  { q:'Quanto un assistente digitale personalizzato potrebbe migliorare l’aderenza', type:'scale', title:'Impatto su aderenza/abbandono' },
  { q:'Consiglieresti ai tuoi clienti', type:'single', title:'Consiglierebbe ai clienti' },
  { q:'Se lo strumento avesse il tuo marchio', type:'single', title:'Interesse white-label' },
  { q:'Quanto pagheresti per un servizio così, per cliente', type:'single', title:'Prezzo per cliente' },
];
const SEC_GYM = [
  { q:'Quanti iscritti attivi', type:'single', title:'Iscritti attivi' },
  { q:'Quanti istruttori', type:'single', title:'Istruttori/PT' },
  { q:'Che tipo di struttura', type:'single', title:'Tipo di struttura' },
  { q:'Quali strumenti digitali usi per gestire struttura', type:'multi', title:'Strumenti gestionali' },
  { q:'Quanto ti pesano questi problemi gestionali', type:'grid', title:'Problemi gestionali (media 1–5)' },
  { q:'Per quel che osservi, perché i tuoi iscritti smettono', type:'multi', title:'Motivi di abbandono soci' },
  { q:'Offri già un servizio di supporto nutrizionale', type:'single', title:'Supporto nutrizionale oggi' },
  { q:'Quanto un assistente AI per i soci potrebbe aumentare i rinnovi', type:'scale', title:'Impatto su rinnovi/fidelizzazione' },
  { q:'Quali funzionalità sarebbero più utili per i tuoi soci', type:'multi', title:'Funzionalità per i soci' },
  { q:'Quanto conterebbe personalizzare lo strumento con il brand', type:'scale', title:'Valore white-label' },
  { q:'Come integreresti uno strumento così', type:'single', title:'Modello di integrazione' },
  { q:'Quanto pagheresti, per iscritto al mese', type:'single', title:'Prezzo per iscritto' },
  { q:'Quale metrica useresti per valutare il successo', type:'multi', title:'Metrica di successo' },
];
const OPEN_QS = [
  { q:'C’è qualcosa che ti semplificherebbe', title:'Cosa semplificherebbe (tutti)' },
  { q:'C’è altro che ti pesa', title:'Note dei professionisti' },
  { q:'Vuoi aggiungere qualcosa sulla gestione', title:'Note delle palestre' },
];

let _headers = null, _data = null, _charts = [], _segment = 'tutti', _tab = 'panoramica', _consid = null, _loaded = false, _menuInjected = false;

const norm = s => (s || '').toString().toLowerCase().replace(/[’'`]/g, "'").trim();
const findCol = p => (_headers || []).find(h => norm(h).startsWith(norm(p))) || null;
const findCols = p => (_headers || []).filter(h => norm(h).startsWith(norm(p)));

function parseCSV(text) {
  const rows = []; let row = [], field = '', i = 0, q = false;
  while (i < text.length) {
    const c = text[i];
    if (q) { if (c === '"') { if (text[i + 1] === '"') { field += '"'; i++; } else q = false; } else field += c; }
    else { if (c === '"') q = true; else if (c === ',') { row.push(field); field = ''; } else if (c === '\n') { row.push(field); rows.push(row); row = []; field = ''; } else if (c !== '\r') field += c; }
    i++;
  }
  if (field.length || row.length) { row.push(field); rows.push(row); }
  return rows;
}
function segmentOf(r) { const v = norm(r[findCol(H_ROUTER)]); if (v.startsWith('come professionista')) return 'pro'; if (v.startsWith('come palestra')) return 'palestra'; return 'consumer'; }
function rowsFor(seg) { return seg === 'tutti' ? _data : _data.filter(r => segmentOf(r) === seg); }
function countSingle(rows, h) { const m = new Map(); rows.forEach(r => { const v = (r[h] || '').trim(); if (v) m.set(v, (m.get(v) || 0) + 1); }); return [...m.entries()].sort((a, b) => b[1] - a[1]); }
function countMulti(rows, h, opts) { return opts.map(o => [o, rows.reduce((a, r) => a + (norm(r[h]).includes(norm(o)) ? 1 : 0), 0)]).filter(x => x[1] > 0).sort((a, b) => b[1] - a[1]); }
function gridAvg(rows, hs) { return hs.map(h => { const v = rows.map(r => parseInt(r[h], 10)).filter(n => !isNaN(n)); const a = v.length ? v.reduce((x, y) => x + y, 0) / v.length : 0; return [(h.match(/\[(.+)\]\s*$/) || [, h])[1], Math.round(a * 100) / 100]; }); }
function scaleStats(rows, h) { const v = rows.map(r => parseInt(r[h], 10)).filter(n => !isNaN(n)); const a = v.length ? v.reduce((x, y) => x + y, 0) / v.length : 0; return { avg: Math.round(a * 100) / 100, n: v.length, dist: [1, 2, 3, 4, 5].map(x => [String(x), v.filter(y => y === x).length]) }; }
function optsFor(q) { const k = Object.keys(MULTI).find(k => norm(q).startsWith(norm(k)) || norm(k).startsWith(norm(q))); return k ? MULTI[k] : []; }

// timestamp Google Forms "gg/mm/aaaa hh.mm.ss" → chiave data + valore ordinabile
function dayKey(ts) { const d = (ts || '').split(' ')[0].trim(); return d; }
function daySort(d) { const m = d.match(/(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2,4})/); return m ? (m[3].length === 2 ? '20' + m[3] : m[3]) + m[2].padStart(2, '0') + m[1].padStart(2, '0') : d; }
function todayCount() { const ks = _data.map(r => dayKey(r[findCol(H_TS)])).filter(Boolean); if (!ks.length) return 0; const last = ks.map(daySort).sort().slice(-1)[0]; return ks.filter(k => daySort(k) === last).length; }

// ── stile + modale ──
function injectStyles() {
  if (document.getElementById('survey-css')) return;
  const s = document.createElement('style'); s.id = 'survey-css';
  s.textContent = `
  #surveyModal .modal{max-width:1000px;width:96%;max-height:92vh;overflow:auto}
  .sv-head{display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;margin-bottom:12px}
  .sv-live{display:inline-flex;align-items:center;gap:6px;font-size:12px;color:var(--ac2);background:rgba(var(--ac-rgb),.12);padding:4px 11px;border-radius:999px}
  .sv-live .d{width:7px;height:7px;border-radius:50%;background:var(--ac)}
  .sv-tabs{display:flex;gap:6px;margin-bottom:16px;border-bottom:1px solid var(--sf3)}
  .sv-tab{font-family:'Barlow Semi Condensed',sans-serif;font-size:15px;letter-spacing:.02em;color:var(--tx3);background:none;border:0;border-bottom:2px solid transparent;padding:8px 4px;margin-right:14px;cursor:pointer}
  .sv-tab.on{color:var(--tx);border-bottom-color:var(--ac);font-weight:700}
  .sv-kpis{display:grid;grid-template-columns:repeat(auto-fit,minmax(120px,1fr));gap:10px;margin-bottom:14px}
  .sv-kpi{background:var(--sf2);border-radius:var(--r-md,10px);padding:12px 14px}
  .sv-kpi .l{font-size:12px;color:var(--tx3);margin-bottom:6px}
  .sv-kpi .v{font-size:24px;font-weight:700;color:var(--tx);line-height:1}
  .sv-kpi .s{font-size:11.5px;color:var(--tx3);margin-top:5px}
  .sv-kpi .s.up{color:var(--ac2)}
  .sv-pills{display:flex;gap:7px;flex-wrap:wrap;margin-bottom:16px}
  .sv-pill{font-size:12.5px;padding:6px 13px;border-radius:999px;border:1px solid var(--sf3);color:var(--tx3);background:none;cursor:pointer}
  .sv-pill.on{background:var(--ac);color:#04241a;border-color:var(--ac);font-weight:700}
  .sv-sec-title{font-family:'Barlow Semi Condensed',sans-serif;font-size:13px;text-transform:uppercase;letter-spacing:.1em;color:var(--tx3);margin:18px 0 10px}
  .sv-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));gap:12px}
  .sv-card{background:var(--sf);border:1px solid var(--sf3);border-radius:var(--r-lg,14px);padding:14px 16px}
  .sv-card h4{font-size:13px;color:var(--tx2);font-weight:600;margin:0 0 4px}
  .sv-card .sub{font-size:11px;color:var(--tx3);margin-bottom:8px}
  .sv-cv{position:relative;width:100%}
  .sv-btn{font-size:12.5px;color:var(--tx2);border:1px solid var(--sf3);background:none;padding:6px 12px;border-radius:var(--r-md,10px);cursor:pointer}
  .sv-quote{display:flex;gap:10px;padding:10px 0;border-top:1px solid var(--sf3)}
  .sv-quote .t{font-size:13px;color:var(--tx);line-height:1.5}
  .sv-empty{font-size:13px;color:var(--tx3);padding:8px 0}
  .sv-consid{background:var(--sf);border:1px solid var(--sf3);border-radius:var(--r-lg,14px);padding:18px 20px;line-height:1.6;color:var(--tx2);font-size:14px}
  .sv-consid h2{font-family:'Barlow Semi Condensed',sans-serif;font-size:17px;color:var(--ac2);text-transform:uppercase;letter-spacing:.06em;margin:18px 0 8px}
  .sv-consid h2:first-child{margin-top:0}
  .sv-consid h3{font-size:14px;color:var(--tx);margin:12px 0 4px}
  .sv-consid strong{color:var(--tx)}
  .sv-consid ul{margin:6px 0;padding-left:20px}
  .sv-consid li{margin:4px 0}
  .sv-note{font-size:11.5px;color:var(--tx3);margin-top:10px}
  `;
  document.head.appendChild(s);
}
function ensureModal() {
  if (document.getElementById('surveyModal')) return;
  injectStyles();
  const el = document.createElement('div'); el.className = 'modal-bg'; el.id = 'surveyModal';
  el.innerHTML = `
    <div class="modal">
      <div class="sv-head">
        <div><h3 style="margin:0">📈 Dashboard sondaggio</h3><div style="font-size:12px;color:var(--tx3)">Solo team · risultati in tempo reale</div></div>
        <div style="display:flex;align-items:center;gap:10px">
          <span class="sv-live"><span class="d"></span><span id="svLive">—</span></span>
          <button class="sv-btn" onclick="closeSurveyDashboard()">✕ Chiudi</button>
        </div>
      </div>
      <div class="sv-tabs">
        <button class="sv-tab" id="svTabP" onclick="setSurveyTab('panoramica')">Panoramica</button>
        <button class="sv-tab" id="svTabC" onclick="setSurveyTab('considerazioni')">Considerazioni</button>
      </div>
      <div id="svContent"><div class="sv-empty">Carico i dati…</div></div>
    </div>`;
  document.body.appendChild(el);
}

async function loadData() {
  const res = await fetch(CSV_URL, { cache: 'no-store' });
  if (!res.ok) throw new Error('HTTP ' + res.status);
  const rows = parseCSV(await res.text());
  _headers = rows[0];
  _data = rows.slice(1).filter(r => r.length > 1 && r.some(c => (c || '').trim())).map(r => { const o = {}; _headers.forEach((h, i) => o[h] = r[i] != null ? r[i] : ''); return o; });
  _loaded = true;
}

function destroyCharts() { _charts.forEach(c => { try { c.destroy(); } catch (_) {} }); _charts = []; }
function chartColors() { const d = window.matchMedia('(prefers-color-scheme:dark)').matches; return { grid: d ? 'rgba(255,255,255,.08)' : 'rgba(0,0,0,.08)', tick: d ? '#b0b0b0' : '#555' }; }

function barCard(container, title, sub, pairs, opts = {}) {
  const card = document.createElement('div'); card.className = 'sv-card';
  if (!pairs.length) { card.innerHTML = `<h4>${title}</h4><div class="sv-empty">Nessun dato in questo segmento.</div>`; container.appendChild(card); return; }
  const h = Math.max(120, pairs.length * 30 + 40);
  card.innerHTML = `<h4>${title}</h4>${sub ? `<div class="sub">${sub}</div>` : ''}<div class="sv-cv" style="height:${h}px"><canvas></canvas></div>`;
  container.appendChild(card);
  const cc = chartColors();
  _charts.push(new Chart(card.querySelector('canvas'), {
    type: 'bar',
    data: { labels: pairs.map(p => p[0]), datasets: [{ data: pairs.map(p => p[1]), backgroundColor: opts.color || AC, borderRadius: 4, maxBarThickness: 26 }] },
    options: { indexAxis: 'y', responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false } },
      scales: { x: { beginAtZero: true, max: opts.max, grid: { color: cc.grid }, ticks: { color: cc.tick, precision: 0, font: { size: 11 } } },
        y: { grid: { display: false }, ticks: { color: cc.tick, font: { size: 11 }, callback: function (v) { const l = this.getLabelForValue(v); return l.length > 34 ? l.slice(0, 33) + '…' : l; } } } } }
  }));
}
function renderSpecInto(container, spec, rows) {
  if (spec.type === 'single') { const h = findCol(spec.q); if (h) barCard(container, spec.title, `n = ${rows.filter(r => (r[h] || '').trim()).length}`, countSingle(rows, h)); }
  else if (spec.type === 'multi') { const h = findCol(spec.q); if (h) barCard(container, spec.title, 'risposta multipla', countMulti(rows, h, optsFor(spec.q)), { color: AC2 }); }
  else if (spec.type === 'grid') { const hs = findCols(spec.q); if (hs.length) barCard(container, spec.title, 'media 1–5', gridAvg(rows, hs), { max: 5 }); }
  else if (spec.type === 'scale') { const h = findCol(spec.q); if (h) { const st = scaleStats(rows, h); barCard(container, spec.title, `media ${st.avg}/5 · n = ${st.n}`, st.dist, { color: AC2 }); } }
}
function section(container, title, specs, rows) {
  const t = document.createElement('div'); t.className = 'sv-sec-title'; t.textContent = title; container.appendChild(t);
  const g = document.createElement('div'); g.className = 'sv-grid'; container.appendChild(g);
  specs.forEach(s => renderSpecInto(g, s, rows));
}
function renderTimeline(container) {
  const h = findCol(H_TS); if (!h) return;
  const m = new Map(); _data.forEach(r => { const k = dayKey(r[h]); if (k) m.set(k, (m.get(k) || 0) + 1); });
  const days = [...m.keys()].sort((a, b) => daySort(a) < daySort(b) ? -1 : 1);
  if (days.length < 2) return;
  let cum = 0; const cumVals = days.map(d => (cum += m.get(d)));
  const card = document.createElement('div'); card.className = 'sv-card'; card.style.marginBottom = '14px';
  card.innerHTML = `<h4>Risposte nel tempo</h4><div class="sub">cumulato</div><div class="sv-cv" style="height:200px"><canvas></canvas></div>`;
  container.appendChild(card);
  const cc = chartColors();
  _charts.push(new Chart(card.querySelector('canvas'), {
    type: 'line',
    data: { labels: days, datasets: [{ data: cumVals, borderColor: AC2, backgroundColor: 'rgba(29,158,117,.14)', fill: true, tension: .3, pointRadius: 2, borderWidth: 2 }] },
    options: { responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false } },
      scales: { x: { grid: { display: false }, ticks: { color: cc.tick, font: { size: 10 }, maxRotation: 0, autoSkip: true } }, y: { beginAtZero: true, grid: { color: cc.grid }, ticks: { color: cc.tick, precision: 0, font: { size: 11 } } } } }
  }));
}

// ── render principale (tab dispatcher) ──
function render() {
  destroyCharts();
  const total = _data.length;
  document.getElementById('svLive').textContent = `${total} risposte`;
  document.getElementById('svTabP').classList.toggle('on', _tab === 'panoramica');
  document.getElementById('svTabC').classList.toggle('on', _tab === 'considerazioni');
  if (_tab === 'considerazioni') renderConsiderazioni();
  else renderPanoramica();
}
const segLabel = s => ({ consumer: 'Utenti', pro: 'Professionisti', palestra: 'Palestre' }[s] || s);

function renderPanoramica() {
  const content = document.getElementById('svContent'); if (!content) return;
  const total = _data.length;
  const nCons = _data.filter(r => segmentOf(r) === 'consumer').length;
  const nPro = _data.filter(r => segmentOf(r) === 'pro').length;
  const nGym = _data.filter(r => segmentOf(r) === 'palestra').length;
  content.innerHTML = `
    <div class="sv-kpis">
      <div class="sv-kpi"><div class="l">Risposte totali</div><div class="v">${total}</div><div class="s up">▲ +${todayCount()} oggi</div></div>
      <div class="sv-kpi"><div class="l">Utenti</div><div class="v">${nCons}</div></div>
      <div class="sv-kpi"><div class="l">Professionisti</div><div class="v">${nPro}</div></div>
      <div class="sv-kpi"><div class="l">Palestre</div><div class="v">${nGym}</div></div>
    </div>
    <div id="svTimeline"></div>
    <div class="sv-pills">
      ${[['tutti','Tutti'],['consumer','Utenti'],['pro','Professionisti'],['palestra','Palestre']].map(([k,l]) => `<button class="sv-pill ${_segment === k ? 'on' : ''}" onclick="setSurveySegment('${k}')">${l}</button>`).join('')}
    </div>
    <div id="svCharts"></div>`;
  renderTimeline(document.getElementById('svTimeline'));
  const charts = document.getElementById('svCharts');
  const common = rowsFor(_segment);
  section(charts, `Profilo & abitudini${_segment !== 'tutti' ? ' · ' + segLabel(_segment) : ''} (n=${common.length})`, SEC_COMMON, common);
  if (_segment === 'tutti' || _segment === 'pro') section(charts, `Professionisti individuali (n=${rowsFor('pro').length})`, SEC_PRO, rowsFor('pro'));
  if (_segment === 'tutti' || _segment === 'palestra') section(charts, `Gestione palestra (n=${rowsFor('palestra').length})`, SEC_GYM, rowsFor('palestra'));
  renderOpen(charts);
}

function renderOpen(container) {
  const t = document.createElement('div'); t.className = 'sv-sec-title'; t.textContent = 'Risposte aperte'; container.appendChild(t);
  OPEN_QS.forEach(o => {
    const h = findCol(o.q); if (!h) return;
    const answers = _data.map(r => (r[h] || '').trim()).filter(Boolean);
    const card = document.createElement('div'); card.className = 'sv-card'; card.style.marginBottom = '12px';
    card.innerHTML = `<h4>${o.title}</h4><div class="sub">${answers.length} risposte</div>`;
    if (!answers.length) card.innerHTML += `<div class="sv-empty">Nessuna risposta.</div>`;
    else answers.slice(0, 8).forEach(a => { const q = document.createElement('div'); q.className = 'sv-quote'; q.innerHTML = `<div class="t">“${a.replace(/</g, '&lt;')}”</div>`; card.appendChild(q); });
    container.appendChild(card);
  });
}

// ── Considerazioni (sintesi strategica AI → framework di validazione) ──
function renderConsiderazioni() {
  destroyCharts();
  const content = document.getElementById('svContent'); if (!content) return;
  content.innerHTML = `
    <div style="display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;margin-bottom:12px">
      <div style="font-size:13px;color:var(--tx3)">Sintesi strategica generata da Claude sui dati attuali. Compila i framework di validazione (Problem–Solution Fit, Javelin, Buyer Personas) e indica cosa manca per decidere la direzione di Coach AI.</div>
      <button class="sv-btn" onclick="genSurveyConsiderazioni(true)">↻ ${_consid ? 'Rigenera' : 'Genera'}</button>
    </div>
    <div id="svConsidBody">${_consid ? _consid : '<div class="sv-empty">Premi "Genera" per la lettura strategica sui ' + _data.length + ' dati attuali.</div>'}</div>`;
  if (!_consid) genSurveyConsiderazioni(false); // auto-genera alla prima apertura
}

function buildAggregatesText() {
  const lines = [];
  const seg = { consumer: rowsFor('consumer').length, pro: rowsFor('pro').length, palestra: rowsFor('palestra').length };
  lines.push(`Totale risposte: ${_data.length}. Segmenti: utenti=${seg.consumer}, professionisti individuali=${seg.pro}, palestre=${seg.palestra}.`);
  const dump = (label, specs, rows) => {
    lines.push(`\n== ${label} (n=${rows.length}) ==`);
    specs.forEach(s => {
      if (s.type === 'single') { const h = findCol(s.q); if (h) lines.push(`${s.title}: ` + countSingle(rows, h).slice(0, 6).map(p => `${p[0]} ${p[1]}`).join(' | ')); }
      else if (s.type === 'multi') { const h = findCol(s.q); if (h) lines.push(`${s.title} (multi): ` + countMulti(rows, h, optsFor(s.q)).slice(0, 6).map(p => `${p[0]} ${p[1]}`).join(' | ')); }
      else if (s.type === 'grid') { const hs = findCols(s.q); if (hs.length) lines.push(`${s.title}: ` + gridAvg(rows, hs).map(p => `${p[0]} ${p[1]}`).join(' | ')); }
      else if (s.type === 'scale') { const h = findCol(s.q); if (h) { const st = scaleStats(rows, h); lines.push(`${s.title}: media ${st.avg}/5 (n=${st.n})`); } }
    });
  };
  dump('PROFILO & ABITUDINI', SEC_COMMON, _data);
  dump('PROFESSIONISTI INDIVIDUALI', SEC_PRO, rowsFor('pro'));
  dump('PALESTRE', SEC_GYM, rowsFor('palestra'));
  const open = [];
  OPEN_QS.forEach(o => { const h = findCol(o.q); if (h) _data.forEach(r => { const v = (r[h] || '').trim(); if (v) open.push('- ' + v); }); });
  if (open.length) lines.push('\n== RISPOSTE APERTE ==\n' + open.slice(0, 60).join('\n'));
  return lines.join('\n');
}

export async function genSurveyConsiderazioni(force) {
  const body = document.getElementById('svConsidBody'); if (!body) return;
  if (_consid && !force) { body.innerHTML = _consid; return; }
  if (typeof window.api !== 'function') { body.innerHTML = '<div class="sv-empty">Sintesi AI non disponibile (serve l’app deployata con /api/anthropic).</div>'; return; }
  body.innerHTML = '<div class="sv-empty">Genero la lettura strategica…</div>';
  const sys = `Sei un analista di validazione startup (metodo lean/PSF/Javelin). A partire da un sondaggio di mercato per "Coach AI" (app fitness: allenamento + alimentazione con AI), compili i framework di validazione per decidere se e come portarla sul mercato e monetizzarla.
Rispondi in ITALIANO, in MARKDOWN, conciso e AZIONABILE. Usa SOLO i dati forniti. Dove il campione di un segmento è piccolo (<15), scrivi esplicitamente "dati insufficienti / bassa confidenza".
Usa ESATTAMENTE questa struttura:

## Verdetto
1–2 frasi: c'è mercato? per chi? come si monetizza?

## Problem–Solution Fit
- **Segmento cliente:** …
- **Problemi / pain (+ frequenza):** …
- **Trigger ad agire:** …
- **Emozioni:** …
- **Soluzioni attuali & limiti:** …
- **Comportamento & canali:** …
- **Root cause:** …
- **Fit della soluzione (AI coach):** segnale forte/debole + perché

## Javelin — stato ipotesi
Per ognuna: ✅ validata / ⚠️ parziale / ❌ smentita / ⏳ dati insufficienti + il dato.
- **Cliente:** …
- **Problema:** …
- **Soluzione:** …
- **Assunzione più rischiosa — disponibilità a pagare:** … (soglia/prezzo dai dati)
- **Assunzione — adozione AI vs coach umano:** …

## Buyer personas (bozza)
1–3 personas dai dati (etichetta, profilo/età, obiettivo, needs, wants, fears, canali, WTP). Nota la confidenza per segmenti piccoli.

## Cosa manca per decidere
- Cosa è validato · cosa manca (es. campione professionisti/palestre troppo piccolo).
- 2–3 mosse consigliate.

Niente testo fuori da questa struttura.`;
  const usr = `Dati del sondaggio (aggregati + risposte aperte):\n\n${buildAggregatesText()}`;
  try {
    const out = await window.api([{ role: 'user', content: usr }], sys, 6000, window.SONNET || undefined);
    const html = (typeof window.parseLightMarkdown === 'function')
      ? window.parseLightMarkdown(out)
      : out.replace(/</g, '&lt;').replace(/\n/g, '<br>');
    _consid = `<div class="sv-consid">${html}</div><div class="sv-note">Generato su ${_data.length} risposte · rigenera per aggiornare al crescere dei dati.</div>`;
    body.innerHTML = _consid;
  } catch (e) {
    body.innerHTML = `<div class="sv-empty">Errore nel generare le considerazioni: ${(e.message || e).toString().slice(0, 140)}</div>`;
  }
}

// ── API pubbliche ──
export async function openSurveyDashboard() {
  ensureModal();
  document.getElementById('surveyModal').classList.add('show');
  try { if (!_loaded) await loadData(); render(); }
  catch (e) { const c = document.getElementById('svContent'); if (c) c.innerHTML = `<div class="sv-empty">Impossibile caricare i dati (${(e.message || e).toString().slice(0, 100)}).</div>`; }
}
export function closeSurveyDashboard() { destroyCharts(); const m = document.getElementById('surveyModal'); if (m) m.classList.remove('show'); }
export function setSurveySegment(seg) { _segment = seg; if (_tab === 'panoramica') renderPanoramica(); }
export function setSurveyTab(tab) { _tab = tab; render(); }

// ── menu admin ──
export function initSurveyMenu() {
  if (_menuInjected || !window.S?.profile?.is_admin) return;
  const items = document.querySelector('.menu-items'); if (!items) return;
  const btn = document.createElement('button'); btn.className = 'menu-item'; btn.id = 'menuSurveyBtn';
  btn.innerHTML = '<span class="menu-item-icon">📈</span>Dashboard sondaggio';
  btn.onclick = () => { if (typeof window.closeMenu === 'function') window.closeMenu(); openSurveyDashboard(); };
  items.appendChild(btn); _menuInjected = true;
}
(function pollAdmin() { let n = 0; const iv = setInterval(() => { n++; if (window.S?.profile) { initSurveyMenu(); clearInterval(iv); } else if (n > 40) clearInterval(iv); }, 500); })();
